
$(".carousel--container").slick({
          "dots":true,
          "infinite": true,
          "mobileFirst": false,
          "slidesToShow":1,
          "slidesToScroll": 1,
          "centerMode": true,
          "variableWidth": true,
          "arrows": false,
        "responsive": [
        {
            "breakpoint": 800,
            "settings": {
            "slidesToShow": 3,
            "arrows": false,
            "slidesToScroll": 1
          }
        },
    {
        "breakpoint": 550,
        "settings": {
        "slidesToShow": 1,
        "arrows": false,
        "slidesToScroll": 1
        }
   }
]
  });

  // Enforce disabled button state with CSS
  const style = document.createElement('style');
  style.textContent = `
    .product-buy-buttons--primary:disabled,
    .product-buy-buttons--primary[disabled],
    .product-buy-buttons--primary[aria-disabled="true"] {
      pointer-events: none !important;
      opacity: 0.5 !important;
      cursor: not-allowed !important;
    }
  `;
  document.head.appendChild(style);


   function getUrlParameter(name) {
     name = name.replace(/\[/g, String.raw`\[`).replace(/\]/g, String.raw`\]`);
     let regex = new RegExp(String.raw`[\?&]` + name + '=([^&#]*)');
     let results = regex.exec(window.location.search);
     return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));

   }

   let maxAvailableOnLoad = 5;
   let currentProductQty = 0;
   let currentVariantId = '';
   let updateMaxQtyTimeout = null;

    // Helper: Check if product is unavailable for purchase (extracted from repeated condition)
   function isProductUnavailable() {
     const addBtn = document.querySelector('.product-buy-buttons--primary');
     return addBtn?.getAttribute('data-available') === 'unavailable';
   }

   // Debounce wrapper to prevent multiple runs
   const debounceUpdateMaxQty = (delay = 300) => {
     if (updateMaxQtyTimeout) {
       clearTimeout(updateMaxQtyTimeout);
     }
     updateMaxQtyTimeout = setTimeout(() => {
       updateMaxQtyProduct();
     }, delay);
   };

   async function getCartItemQty() {
     try {
       const response = await fetch('/cart.js');
       if (!response.ok) return 0;
       
       const cart = await response.json();
       if (!cart.items) return 0;
       if (!Array.isArray(cart.items)) return 0;
       
       // Get current variant ID from form (always required)
       const variantIdInput = document.querySelector('input[name="id"]');
       if (!variantIdInput?.value) return 0;
       
       const variantId = parseInt(variantIdInput.value);
       
       // SCENARIO 1: Check if .pss__btn--selected exists (size/option selector)
       const selectedOptionElement = document.querySelector('.pss__btn--selected');
       const hasOptionSelector = selectedOptionElement !== null;
       const selectedOption = selectedOptionElement?.getAttribute('data-value') || '';
       
       // SCENARIO 2: Check if .og-card exists (subscription selector)
       const ogCardElement = document.querySelector('.og-card');
       const hasSubscriptionSelector = ogCardElement !== null;
       const isSubscription = document.querySelector('.og-card.sub-active') !== null;
       
       // SCENARIO 3: Fallback - Get product handle/title for fallback matching
       const productHandle = document.querySelector('[data-product-handle]')?.getAttribute('data-product-handle') || 
                            Shopify?.product?.handle || 
                            window.productHandle || '';
       
       // Build match criteria dynamically based on available elements
       const cartItem = cart.items.find(item => {
         // ALWAYS match variant_id (primary key)
         const variantMatch = item.variant_id === variantId;
         if (!variantMatch) return false;
         
         // SCENARIO 1: If .pss__btn--selected exists, consider option matching
         if (hasOptionSelector) {
           const optionMatch = item.variant_options?.[0] === selectedOption;
           if (!optionMatch) {
             return false;
           }
         }
         
         // SCENARIO 2: If .og-card exists, consider subscription matching
         if (hasSubscriptionSelector) {
           const subscriptionMatch = isSubscription 
             ? !!item.selling_plan_allocation  // If currently subscription, cart item must be subscription
             : !item.selling_plan_allocation;   // If currently one-time, cart item must be one-time
           
           if (!subscriptionMatch) {
             return false;
           }
         }
         
         // SCENARIO 3: If neither selector exists, match by product handle as fallback
         if (!hasOptionSelector && !hasSubscriptionSelector && productHandle) {
           const handleMatch = item.handle === productHandle;
           if (!handleMatch) {
             return false;
           }
         }
         
         return true;
       });
       
       const qty = cartItem?.quantity || 0;
       return qty;
     } catch (error) {
       return 0;
     }
   }

   async function updateMaxQtyProduct() {
     try {
       // Step 0: Check if product is marked as unavailable for purchase
       const addBtn = document.querySelector('.product-buy-buttons--primary');
      if (isProductUnavailable()) {
         document.querySelectorAll(".quantity-selector--plus").forEach(function(el){
        
           el.setAttribute('disabled', 'disabled');
         });
         return;
       }

       // Step 1: Get current variant ID from form's hidden input (standard Shopify)
       const variantIdInput = document.querySelector('input[name="id"]');
       if (!variantIdInput?.value) {
         return;
       }
       currentVariantId = variantIdInput.value;

       currentProductQty = await getCartItemQty();
       const qtyInput = document.querySelector('.quantity-selector--input');
       const qtyUpdate = document.querySelector('product-buy-buttons-element.product-buy-buttons--root .qtyUpdate');

      if (!qtyInput) return;
      if (!qtyUpdate) return;
      maxAvailableOnLoad = Math.max(1, 5 - currentProductQty);
       
      qtyInput.max = maxAvailableOnLoad;
      qtyInput.value = Math.min(parseInt(qtyInput.value, 10), maxAvailableOnLoad);
      qtyUpdate.classList.remove('cart-quantity-error');

       if (currentProductQty >= 5) {      
         qtyUpdate.textContent = 'Maximum quantity already in cart';
         qtyUpdate.style.display = 'block';

       } else if (currentProductQty > 0) {       
         qtyUpdate.textContent = currentProductQty + ' already in cart';
         qtyUpdate.style.display = 'block';

       } else {
         qtyUpdate.style.display = 'none';
            addBtn?.removeAttribute('disabled');
            addBtn?.removeAttribute('aria-disabled');
       }
       updateQtyMaxvalue(maxAvailableOnLoad);

       updateMaxQtyProductOnClick();
       syncPlusButtonsWithAddBtn();
       
       // Schedule sync ONLY if product is available
       if (!isProductUnavailable()) {
         setTimeout(() => syncQuantitySelectors(), 1000);
       }
     } catch (error) {
       return;
     }
     return currentProductQty;
   }
function checkApp() {
  // Check if og-block-active exists
  const ogBlockActive = document.querySelector('.shopify-block.shopify-app-block.og-block-active');
  if (ogBlockActive !== null) {
    // og-block-active is present, skip margin adjustments
    return;
  }
  
  // og-block-active is null, proceed with ordergroove block styling
  // Step 1: Find the ordergroove subscriptions app block by id
  const appBlocks = document.querySelectorAll('.shopify-block.shopify-app-block');
  let ordergrooveBlock = null;
  
  for (const block of appBlocks) {
    if (block.id?.includes('ordergroove_subscriptions_pdp_offer')) {
      ordergrooveBlock = block;
      break;
    }
  }

  // Step 2: If ordergroove block found, navigate to parent and apply styles
  if (ordergrooveBlock) {
    const parentWrapper = ordergrooveBlock.closest('div[class*="product-form--block"][class*="@app"]');
    if (parentWrapper) {
      parentWrapper.classList.add('test');
      parentWrapper.style.setProperty('margin-top', '0');
    }
  }
  
  // Step 3: Handle badge margin
  const badge = document.querySelector('.product-club-olay--badge');
  if (badge) {
    badge.style.setProperty('margin-bottom', '0');
  }
}
   function updateQtyMaxvalue(maxAvailable) {
     const inputs = document.querySelectorAll('.product-buy-buttons--root .quantity-selector--input');
     if (!inputs.length) return;

     inputs.forEach(input => {
       input.max = maxAvailable;
       const clampValue = () => {
         const value = Number(input.value);
         if (value > maxAvailable) input.value = maxAvailable;
       };
       input.addEventListener('input', clampValue);
     });
   }

   function updateMaxQtyProductOnClick() {
     const qtyInput = document.querySelector('.quantity-selector--input');
     const addBtn = document.querySelector('.product-buy-buttons--primary');

     // Guard: If product unavailable, don't enable any buttons
     if (isProductUnavailable()) {
       return;
     }

     if (!qtyInput) return;

     const selectedQty = parseInt(qtyInput.value, 10) || 1;

     // ONLY affect PDP quantity selectors, NOT cart buttons
     const plusBtns = document.querySelectorAll('.product-form .quantity-selector--plus, .product-buy-buttons--drawer-quantity .quantity-selector--plus');
     const minusBtns = document.querySelectorAll('.product-form .quantity-selector--minus, .product-buy-buttons--drawer-quantity .quantity-selector--minus');

     // Disable plus buttons if qty >= maxAvailable
     // Example: If cart has 4, maxAvailable=1, selectedQty=1 → 1 >= 1 → DISABLE plus
     if (selectedQty >= maxAvailableOnLoad) {
       plusBtns.forEach(btn => {
         btn.setAttribute('disabled', 'disabled');
         btn.setAttribute('aria-disabled', 'true');
       });
     } else {
       plusBtns.forEach(btn => {
         btn.removeAttribute('disabled');
         btn.removeAttribute('aria-disabled');
       });
     }

     // Disable minus buttons if qty <= 1
     if (minusBtns.length) {
       minusBtns.forEach(btn => {
         const isDisabled = selectedQty <= 1;
         btn.toggleAttribute('disabled', isDisabled);
         btn.setAttribute('aria-disabled', String(isDisabled));
       });
     }

     // Disable Add to Cart button if combined quantity exceeds limit
     // Example: cart has 4, user wants to add 2 → 4 + 2 = 6 > 5 limit → DISABLE add
     const wouldExceedLimit = currentProductQty + selectedQty > 5;
     if (addBtn && wouldExceedLimit) {
      if (!addBtn.hasAttribute('data-wouldExceedLimit')) {
          addBtn.setAttribute('data-wouldExceedLimit', 'true');
      }
     }
   }

   function syncQuantitySelectors() {
     const mainInput = document.querySelector('.product-form .quantity-selector--input');
     const stickyInput = document.querySelector('.product-buy-buttons--drawer-quantity .quantity-selector--input');
     const mainContainer = document.querySelector('.product-form quantity-selector');
     const stickyContainer = document.querySelector('.product-buy-buttons--drawer-quantity quantity-selector');

     // Guard: If product unavailable, skip syncing and keep buttons disabled
     const addBtn = document.querySelector('.product-buy-buttons--primary');
     if (addBtn?.hasAttribute('data-available') && addBtn.getAttribute('data-available') === 'unavailable') {
       return;
     }

     if (!mainInput || !stickyInput || !mainContainer || !stickyContainer) {
       return;
     }

     // Define updateButtonStates for each container
     const updateButtonStates = (container, value) => {
       if (!container) return;
       const updateBtn = (selector, isDisabled) => {
         const btn = container.querySelector(selector);
         if (btn) {
           btn.toggleAttribute('disabled', isDisabled);
           btn.setAttribute('aria-disabled', String(isDisabled));
         }
       };
       updateBtn('.quantity-selector--plus', value >= maxAvailableOnLoad);
       updateBtn('.quantity-selector--minus', value <= 1);
     };

     // Define updateAllButtonStates — updates BOTH main and sticky
     const updateAllButtonStates = (value) => {
       updateButtonStates(document.querySelector('.product-form quantity-selector'), value);
       updateButtonStates(document.querySelector('.product-buy-buttons--drawer-quantity quantity-selector'), value);
     };

     // Define syncFromInput — bidirectional sync between two inputs
     const syncFromInput = (sourceInput, targetInput) => {
       if (!sourceInput) return;
       if (!targetInput) return;
       sourceInput.addEventListener('change', () => {
         if (sourceInput.value !== targetInput.value) {
           targetInput.value = sourceInput.value;
         }
         updateAllButtonStates(sourceInput.value);
       });
     };

     // NOW call the functions (after definitions)
     syncFromInput(mainInput, stickyInput);
     syncFromInput(stickyInput, mainInput);
    syncPlusButtonsWithAddBtn();
     updateAllButtonStates(parseInt(mainInput.value, 10) || 1);
   };

function syncPlusButtonsWithAddBtn() { 
  const addBtn = document.querySelector('.product-buy-buttons--primary');

  const plusBtns = document.querySelectorAll(
    '.product-form .quantity-selector--plus, ' +
    '.product-buy-buttons--drawer-quantity .quantity-selector--plus'
  );
  
  if (!plusBtns.length) return;

  // Guard: Always disable plus buttons if product is unavailable
  if (addBtn?.hasAttribute('data-available') && addBtn.getAttribute('data-available') === 'unavailable') {
    plusBtns.forEach(btn => {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
    });
    return;
  }
  
  const isAddBtnDisabled = addBtn?.hasAttribute('disabled');
  
  plusBtns.forEach(btn => {
    if (isAddBtnDisabled) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');      
    } 
  });
}

// ========================================================
// EVENT LISTENERS — Setup OUTSIDE DOMContentLoaded
// (These must run immediately when script loads)
// ========================================================

// Listen for Ordergroove subscription option changes (.og-card)
document.addEventListener('click', (e) => {
  const ogCard = e.target.closest('.og-card');
  if (ogCard) {
    const isOneTime = ogCard.classList.contains('og-card--onetime');
    const isSubscribe = ogCard.classList.contains('og-card--subscribe');
    
    // Wait for Ordergroove to update form/variant, then recalculate
    if (typeof debounceUpdateMaxQty === 'function') {
      debounceUpdateMaxQty(500);
    }
  }
}, true); // Use capture phase to catch clicks early

// Listen for size/variant selector changes (pss__btn)
document.addEventListener('click', (e) => {
  const pssBtn = e.target.closest('.pss__btn');
  if (pssBtn) {
    const isSelected = pssBtn.classList.contains('pss__btn--selected');
    const variantId = pssBtn.getAttribute('data-variant-id');
    const value = pssBtn.getAttribute('data-value');
    
    // Wait for form to update variant ID, then recalculate
    if (typeof debounceUpdateMaxQty === 'function') {
      debounceUpdateMaxQty(100);
    } else {
      return;
    }
  }
}, true); // Use capture phase to catch clicks early

   document.addEventListener('DOMContentLoaded', function() {
          
          // Log initial selections
          const selectedOgCard = document.querySelector('.og-card.one-active, .og-card.sub-active');
          const selectedPssBtn = document.querySelector('.pss__btn--selected');
          
          if (getUrlParameter('pswtb') !== null) {             
            let psWidget = document.querySelector('.ps-widget');
            
           if (psWidget) {             
               // Wait 3 seconds before simulating a real user click event
               setTimeout(function() {
                 psWidget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
               }, 3000);
            }
          }
          
          updateMaxQtyProduct();
          document.addEventListener('cart:updated', updateMaxQtyProduct);

          // Run checkApp() once after page fully loads to apply margin styles
          window.addEventListener('load', () => {
            checkApp();
          });

          // Intercept cart add to enforce quantity limit
          const originalFetch = window.fetch;
          window.fetch = async (...args) => {
            const [url, options] = args;
            if (typeof url === 'string' && url.includes('/cart/add.js')) {
              await updateMaxQtyProduct();
              if (currentProductQty >= 5) {
                const qtyUpdate = document.querySelector('product-buy-buttons-element.product-buy-buttons--root .qtyUpdate');
                if (qtyUpdate) {
                   qtyUpdate.classList.add('cart-quantity-error');
                  qtyUpdate.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                      '<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="1.5"/>'+
                      '<path d="M12 8V12M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'+
                    '</svg> Maximum quantity allowed in the cart is 5';
                  qtyUpdate.style.display = 'flex';
                }
                throw new Error('Maximum quantity allowed in the cart is 5');
              }
            }
            return originalFetch.apply(this, args);
          };

          // Validate on quantity input change
          const qtyInput = document.querySelector('.quantity-selector--input');
          if (qtyInput) {
            const updateQtyErrorClass = () => {
              const qtySelector = document.querySelector('.quantity-selector--root');
              const inputValue = parseInt(qtyInput.value, 10) || 0;
              if (qtySelector) qtySelector.classList.toggle('qty-error', inputValue > 5);
            };
            qtyInput.addEventListener('change', updateQtyErrorClass);
            qtyInput.addEventListener('input', (e) => {
              updateQtyErrorClass();
              updateMaxQtyProductOnClick();
            });
            updateQtyErrorClass();
          }

          // Prevent exceeding max on Add to Cart
          const addBtn = document.querySelector('.product-buy-buttons--primary');
          const productForm = addBtn?.closest('form');
          
          if (productForm) {
            productForm.addEventListener('submit', async (e) => {
              currentProductQty = await getCartItemQty();
              const qtyInput =  document.querySelectorAll("product-buy-buttons-element.product-buy-buttons--root .quantity-selector--input")[0];
              const selectedQty = parseInt(qtyInput?.value, 10) || 1;
              const qtyUpdate = document.querySelector('product-buy-buttons-element.product-buy-buttons--root .qtyUpdate');
              
              if (selectedQty > (5 - currentProductQty)) {
                e.preventDefault();
                e.stopPropagation();
                if (qtyUpdate) {
                   qtyUpdate.classList.add('cart-quantity-error');
                  qtyUpdate.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                      '<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="1.5"/>'+
                      '<path d="M12 8V12M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'+
                    '</svg> Maximum quantity allowed in the cart is 5';
                  qtyUpdate.style.display = 'flex';
                }
                return;
              }
            setTimeout(() => syncQuantitySelectors(), 1000);
            });
          }

          // Reset PDP quantity when drawer closes
          const viewport = document.querySelector('.layout--viewport');
          if (viewport) {
            new MutationObserver(() => {
              if (viewport.getAttribute('data-drawer-status') === 'closed') {
                const qtyInput = document.querySelector('.product-buy-buttons--root .quantity-selector--input');
                const qtyInput_sticky = document.querySelector('.product-buy-buttons--drawer-quantity .quantity-selector--input');
                if (qtyInput) qtyInput.value = 1;
                if (qtyInput_sticky) qtyInput_sticky.value = 1;
                if (typeof updateMaxQtyProduct === 'function') updateMaxQtyProduct();
              }
            }).observe(viewport, { attributes: true, attributeFilter: ['data-drawer-status'] });
          }
        });

(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateMaxQtyProduct);
  } else {
    updateMaxQtyProduct();
  }
})();